<template>
  <!-- Wearable Electronics Printed Start -->
  <div class="electronics-printed">
    <!-- ** Baby Mat Start ** -->
    <div class="sports-wearable">
      <b-row class="wearable">
        <b-col lg="" class="wearable__content">
          <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
            <span>{{$t('wearable.wearable.title')}}</span>
          </div>
          <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
            <span v-html="$t('wearable.wearable.sub-title')"></span>
            <span class="sub-title__exp" v-html="$t('wearable.wearable.sub-title-exp')"></span>
          </div>
          <b-col cols="12" lg="auto" class="wearable__image-1"
                 data-aos="fade-up" :data-aos-duration="duration">
            <div>
              <img src="@/assets/img/products/wearable/img_fitness_wearable_cc.png" alt="wearable"/>
            </div>
          </b-col>

          <div class="content__info">
            <div class="info__exp" data-aos="fade-up" >
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-1.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-1.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-1.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-1.info')"></b-col>
              </b-col>
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-2.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-2.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-2.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-2.info')"></b-col>
              </b-col>
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-3.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-3.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-3.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-3.info')"></b-col>
              </b-col>
            </div>
            <div class="info__exp" data-aos="fade-up" >
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-4.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-4.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-4.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-4.info')"></b-col>
              </b-col>
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-5.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-5.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-5.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-5.info')"></b-col>
              </b-col>
              <b-col class="exp__item" cols="4" data-aos="fade-up" :data-aos-duration="duration">
                <b-col class="item__no" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-6.no')"></b-col>
                <b-col class="item__title" data-aos="fade-up" :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-6.title')"></b-col>
                <b-col v-if="$i18n.locale() === 'ko'" class="item__info-ko" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-6.info')"></b-col>
                <b-col v-else class="item__info-en" data-aos="fade-up"
                       :data-aos-duration="duration"
                       v-html="$t('wearable.wearable.item-6.info')"></b-col>
              </b-col>
            </div>
          </div>

          <b-col cols="12" lg="auto" class="wearable__image-2"
                 data-aos="fade-up" :data-aos-duration="duration">
            <div>
              <img src="@/assets/img/products/wearable/img_fitness_wearable_img1.png"
                   alt="wearable"/>
              <img src="@/assets/img/products/wearable/img_fitness_wearable_line1.png"
                   alt="wearable"/>
              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-1-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-1')"></b-col>
              <b-col v-else class="item__text-1-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-1')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-2-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-2')"></b-col>
              <b-col v-else class="item__text-2-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-2')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-3-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-3')"></b-col>
              <b-col v-else class="item__text-3-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-3')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-4-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-4')"></b-col>
              <b-col v-else class="item__text-4-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-4')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-5-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-5')"></b-col>
              <b-col v-else class="item__text-5-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-1.text-5')"></b-col>

            </div>
          </b-col>
          <b-col cols="12" lg="auto" class="wearable__image-3"
                 data-aos="fade-up" :data-aos-duration="duration">
            <div>
              <img src="@/assets/img/products/wearable/img_fitness_wearable_img2.png"
                   alt="wearable"/>
              <img src="@/assets/img/products/wearable/img_fitness_wearable_line2.png"
                   alt="wearable"/>
              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-1-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-1')"></b-col>
              <b-col v-else class="item__text-1-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-1')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-2-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-2')"></b-col>
              <b-col v-else class="item__text-2-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-2')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-3-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-3')"></b-col>
              <b-col v-else class="item__text-3-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-3')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-4-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-4')"></b-col>
              <b-col v-else class="item__text-4-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-4')"></b-col>

              <b-col v-if="$i18n.locale() === 'ko'" class="item__text-5-ko" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-5')"></b-col>
              <b-col v-else class="item__text-5-en" data-aos="fade-up"
                     :data-aos-duration="duration"
                     v-html="$t('wearable.wearable.picture-2.text-5')"></b-col>

            </div>
          </b-col>
        </b-col>
      </b-row>
    </div>
    <!-- ** Baby Mat End ** -->

    <!-- ** Baby Light Start ** -->
    <div class="sports-hardware">
      <div class="hardware__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('wearable.hardware.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('wearable.hardware.sub-title')"></span>
          <span class="sub-title__exp" v-html="$t('wearable.hardware.sub-title-exp')"></span>
        </div>
      </div>
      <b-row class="hardware">
        <b-col lg="" class="hardware__content">
          <b-row class="content__info">
            <b-col class="info__item" cols="8"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="@/assets/img/products/wearable/img_fitness_customize.png" alt="light"/>
              <span>{{$t('wearable.hardware.customizable')}}</span>
            </b-col>
            <b-col class="info__item" cols="8"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="@/assets/img/products/wearable/img_fitness_charge.png" alt="warning"/>
              <span>{{$t('wearable.hardware.detachable')}}</span>
            </b-col>
            <b-col class="info__item" cols="8"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="@/assets/img/products/wearable/img_fitness_magnet.png" alt="temp"/>
              <span>{{$t('wearable.hardware.magnetic')}}</span>
            </b-col>
            <b-col class="info__item" cols="8"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="@/assets/img/products/wearable/img_fitness_light.png" alt="humidity"/>
              <span>{{$t('wearable.hardware.light-weight')}}</span>
            </b-col>
          </b-row>
        </b-col>

        <!-- ** Baby Light Image Start ** -->
        <b-col cols="12" lg="auto" class="hardware__image"
               data-aos="fade-up" :data-aos-duration="duration">
          <div>
            <img src="@/assets/img/products/wearable/img_fitness_2.png" alt="wearable"/>
            <img src="@/assets/img/products/wearable/img_fitness_2_red.png" alt="wearable"/>
          </div>
        </b-col>
        <!-- ** Baby Light Image End ** -->
      </b-row>
    </div>
  </div>
  <!-- Wearable Electronics Printed End -->
</template>

<script>
import { FadeUpMixin } from '../mixins/FadeUp';

export default {
  name: 'WearableElectronicsPrinted',
  data() {
    return {
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/constant';
@import '../../assets/scss/mixins';

/* ------------------
  :: Product Baby CSS
  ------------------ */
.electronics-printed {
  @include flexbox;
  @include flex-direction(column);
  align-items: center;
  padding: 122px 40px 20px;
  & > div {
    width: 100%;
    max-width: 1518px;
  }
  .content {
    &__title {
      color: $color-light-gray;
    }
    &__info {
      font-size: 16px;
    }
  }
  .info__item {
    @include flexbox;
    @include flex-direction(row);
    @include align-items(center);
    padding: 0;
    & > img {
      width: 60px;
      height: 60px;
    }
    & > span {
      word-break: break-all;
    }
  }
}
@media (min-width: 648px) {
  .product-baby-item {
    padding: 184px 40px 148px;
    .content {
      &__info {
        font-size: 20px;
      }
    }
    .info__item {
      & > img {
        width: 100px;
        height: 100px;
      }
    }
  }
}

/* ------------------
  :: Baby Mat CSS
  ------------------ */
.sports-wearable {
  flex-shrink: 0;
}
.wearable
{
  &__content {
    max-width: 1240px;
    padding: 0;
    position: relative;
  }

  .info__exp {
    margin-top: 30px;
    margin-bottom: 30px;

    .item__no {
      min-width: 320px;
      font-size: 36px;
      margin-bottom: 5px;
      left: -15px;
    }

    .item__title {
      min-width: 320px;
      font-size: 25px;
      margin-bottom: 10px;
      left: -15px;
    }

    .item__info-ko {
      min-width: 300px;
      font-size: 16px;
      text-align: left;
      margin-bottom: 40px;
      left: -15px;
    }

    .item__info-en {
      min-width: 380px;
      font-size: 16px;
      text-align: left;
      margin-bottom: 40px;
      left: -15px;
    }

  }

  &__image-2 {
    position: relative;
    margin-top: 100px;

    &> div{

      &> div{
        position: absolute;
        text-align: left;
        left: 0px;
      }

      .item__text-1-ko {
        font-size: 35px;
        font-weight: bold;
        top: 145px;
        left: 255px;
      }
      .item__text-2-ko {
        font-size: 20px;
        font-weight: bold;
        top: 160px;
        left: 300px;
      }
      .item__text-3-ko {
        font-size: 20px;
        font-weight: bold;
        top: 125px;
        left: 240px;
      }
      .item__text-4-ko {
        min-width: 330px;
        font-size: 30px;
        font-weight: bold;
        line-height: 1.15;
        top: 230px;
      }
      .item__text-5-ko {
        min-width: 320px;
        font-size: 16px;
        top: 290px;
      }

      .item__text-1-en {
        font-size: 35px;
        font-weight: bold;
        top: 115px;
        left: 255px;
      }
      .item__text-2-en {
        font-size: 20px;
        font-weight: bold;
        top: 130px;
        left: 300px;
      }
      .item__text-3-en {
        font-size: 16px;
        font-weight: bold;
        top: 160px;
        left: 205px;
      }
      .item__text-4-en {
        min-width: 330px;
        font-size: 30px;
        font-weight: bold;
        line-height: 1.15;
        top: 230px;
      }
      .item__text-5-en {
        width: 440px;
        font-size: 16px;
        top: 320px;
      }

      & > img:first-child {
        position: relative;
        width: 270px;
        height: 270px;
        object-fit: cover;
        margin-bottom: 100px;
        left: -40px;
        bottom: 40px;
      }

      & > img:last-of-type {
        visibility: hidden;
      }
    }
  }

  &__image-3 {

    position: relative;
    margin-bottom: 150px;

    &> div{

      &> div{
        position: absolute;
        text-align: left;
        left: 0px;
      }

      .item__text-1-ko {
        font-size: 35px;
        font-weight: bold;
        top: 190px;
      }
      .item__text-2-ko {
        font-size: 20px;
        font-weight: bold;
        top: 207px;
        left: 47px;
      }
      .item__text-3-ko {
        font-size: 20px;
        font-weight: bold;
        top: 240px;
      }
      .item__text-4-ko {
        min-width: 330px;
        font-size: 30px;
        font-weight: bold;
        line-height: 1.15;
        top: 310px;
      }
      .item__text-5-ko {
        min-width: 320px;
        font-size: 16px;
        top: 360px;
      }

      .item__text-1-en {
        font-size: 35px;
        font-weight: bold;
        top: 210px;
      }
      .item__text-2-en {
        font-size: 20px;
        font-weight: bold;
        top: 224px;
        left: 60px;
      }
      .item__text-3-en {
        font-size: 16px;
        font-weight: bold;
        top: 190px;
      }
      .item__text-4-en {
        min-width: 330px;
        font-size: 30px;
        font-weight: bold;
        line-height: 1.15;
        top: 300px;
      }
      .item__text-5-en {
        width: 470px;
        font-size: 16px;
        top: 390px;
      }

      & > img:first-child{
        margin-top: 100px;
        position: relative;
        width: 270px;
        height: 270px;
        object-fit: cover;
        left: 50px;
        bottom: 70px;
      }

      & > img:last-of-type {
        visibility: hidden;
      }
    }
  }

  &__image-1 {
    margin-top: 50px;
    padding: 0;
    flex: 0 0 100%;
    &> div{
      width: 100%;
      position: relative;
      margin-bottom: 00px;

      @include flexbox;
      @include flex-direction(column);
      @include align-items(flex-end);
      flex-shrink: 0;

      & > img {
        width: 100%;
        height: auto;
        flex-shrink: 0;
      }
    }
  }
}

@media (min-width: 1350px) {
  .wearable {
    &__content {
      position: relative;
    }

    .info__exp {
      display: flex;
      margin-top: 30px;
      margin-bottom: 30px;

      .item__no {
        font-size: 46px;
        margin-bottom: 3px;
      }

      .item__title {
        font-size: 30px;
        margin-bottom: 25px;
      }

      .item__info-ko {
        min-width: 300px;
        font-size: 20px;
        text-align: left;
        margin-bottom: 40px;
      }

      .item__info-en {
        min-width: 380px;
        font-size: 20px;
        text-align: left;
        margin-bottom: 40px;
      }

    }

    &__image-2 {

      position: relative;
      margin-top: 150px;

      &> div{

        &> div{
          position: absolute;
          text-align: right;
        }

        .item__text-1-ko {
          font-size: 100px;
          font-weight: bold;
          left: 230px;
          top: 90px;
        }
        .item__text-2-ko {
          font-size: 40px;
          font-weight: bold;
          left: 270px;
          top: 160px;
        }
        .item__text-3-ko {
          font-size: 30px;
          font-weight: bold;
          left: 90px;
          top: 170px;
        }
        .item__text-4-ko {
          font-size: 40px;
          font-weight: bold;
          line-height: 1.15;
          left: 270px;
          top: 270px;
        }
        .item__text-5-ko {
          width: 440px;
          font-size: 20px;
          top: 340px;
          left: 1070px;
        }

        .item__text-1-en {
          font-size: 100px;
          font-weight: bold;
          left: 230px;
          top: 30px;
        }
        .item__text-2-en {
          font-size: 40px;
          font-weight: bold;
          left: 270px;
          top: 100px;
        }
        .item__text-3-en {
          font-size: 30px;
          font-weight: bold;
          left: 270px;
          top: 165px;
        }
        .item__text-4-en {
          font-size: 40px;
          font-weight: bold;
          line-height: 1.15;
          left: 270px;
          top: 260px;
        }
        .item__text-5-en {
          width: 440px;
          font-size: 20px;
          top: 380px;
          left: 1070px;
        }

        & > img{
          position: absolute;
        }

        & > img:first-child {
          left: 230px;
          width: 731px;
          height: 751px;
          margin-bottom: 0px;
        }

        & > img:last-of-type {
          visibility: visible;
          position: absolute;
          width: 690px;
          height: 140px;
          object-fit: none;
          left: 825px;
          bottom: 400px;
        }
      }
    }

    &__image-3 {

      position: relative;
      margin-bottom: 0px;

      &> div{
        &> div{
          position: absolute;
          text-align: left;
        }

        .item__text-1-ko {
          font-size: 100px;
          font-weight: bold;
          left: 80px;
          top: 170px;
        }
        .item__text-2-ko {
          font-size: 40px;
          font-weight: bold;
          left: 210px;
          top: 235px;
        }
        .item__text-3-ko {
          font-size: 30px;
          font-weight: bold;
          left: 260px;
          top: 250px;
        }
        .item__text-4-ko {
          font-size: 40px;
          font-weight: bold;
          line-height: 1.15;
          left: 80px;
          top: 100px;
        }
        .item__text-5-ko {
          width: 470px;
          font-size: 20px;
          top: 320px;
          left: 80px;
        }

        .item__text-1-en {
          font-size: 100px;
          font-weight: bold;
          left: 80px;
          top: 240px;
        }
        .item__text-2-en {
          font-size: 40px;
          font-weight: bold;
          left: 250px;
          top: 310px;
        }
        .item__text-3-en {
          font-size: 30px;
          font-weight: bold;
          left: 80px;
          top: 200px;
        }
        .item__text-4-en {
          font-size: 40px;
          font-weight: bold;
          line-height: 1.15;
          left: 80px;
          top: 50px;
        }
        .item__text-5-en {
          width: 470px;
          font-size: 20px;
          top: 390px;
          left: 90px;
        }

        & > img{
          position: absolute;
        }

        & > img:first-child {
          bottom: 200px;
          left: 650px;
          width: 753px;
          height: 751px;
          margin-bottom: 100px;
        }

        & > img:last-of-type {
          visibility: visible;
          position: absolute;
          width: 820px;
          height: 140px;
          object-fit: none;
          left: 80px;
          bottom: 670px;
        }
      }
    }

    &__image-1 {
      flex: 1;
      &> div{
        margin-bottom: 0;
        min-height: 300px;
      }
    }

  }
}

/* ------------------
  :: Mat Animation CSS
  ------------------ */
@keyframes wearableFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@-webkit-keyframes wearableFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.TECHNOLOGY {
  width: 118px;
  height: 23px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: 1.28px;
  text-align: center;
  color: #fff;
}

/* ------------------
  :: Baby Light CSS
  ------------------ */
.sports-hardware {
  flex-shrink: 0;
}
.hardware {
  &__content {
    padding: 0;
    max-width: 970px;
  }
  &__image {
    padding: 0;
    flex: 0 0 100%;
    margin-top: 50px;
    &> div{
      width: 100%;
      position: relative;
      margin-bottom: 100px;

      @include flexbox;
      @include flex-direction(column);
      @include align-items(flex-end);
      flex-shrink: 0;

      & > img {
        width: 100%;
        max-width: 1020px;
        height: auto;
        flex-shrink: 0;
      }

      & > img:last-of-type {
        animation: wearableFadeIn 0.5s infinite alternate;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}
@media (min-width: 992px) {
  .hardware {
    &__image {
      flex: 1;
      &> div{
        margin-top: 50px;
        margin-bottom: 0;
        min-height: 700px;
      }
    }
  }
}
</style>
